<template>
    <div class="text-center">
        <a :href="giftCard.url">
            <img-mirror
                img-class="m-auto space-x-1"
                :url="giftCard.img"
                :display-mirror="false"
            />
        </a>
        <div class="mt-3 md:px-4">
            <h4 class="font-secondary">
                {{ giftCard.name }}
            </h4>
            <p class="font-secondary">
                {{ giftCard.price | price }}
            </p>
            <p class="text-xl" v-if="giftCard.deactivated_at" >
                {{ __('Brak kart upominkowych w sprzedaży') }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        giftCard: Object
    }
};
</script>
